<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/35u3RI/tc-custom/9781644570944.jpg?1685327317574" alt="This image is the cover for the book The Daisy Gumm Majesty Cozy Mystery Box Set 3 (Three Complete Cozy Mystery Novels in One), Daisy Gumm Majesty Mystery"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Daisy Gumm Majesty Cozy Mystery Box Set 3 (Three Complete Cozy Mystery Novels in One), Daisy Gumm Majesty Mystery
      </h1>
      <p class="bookDescription body article font2">
        <b>In 1920s Pasadena, CA, Daisy Gumm Majesty Matches Wits With Three Villains in this Box Set Filled With Light Humor and Period Charm</b><br/><br/><b>SPIRITS REVIVED:</b> Pasadena's beloved spiritualist to people with more money than sense, gets her man when a real spirit seeks Daisy's help in catching his murderer.<br/><br/><b>DARK SPIRITS:</b> When the Ku Klux Klan opens a chapter in Pasadena, California, Sam Rotundo, Daisy's new leading man, must keep Daisy from doing in the Klan with a zinc bucket and a baseball bat.<br/><br/><b>SPIRITS ONSTAGE:</b> Daisy is talked into playing a role in her church's production of Mikado. But when the producer's wife experiences a mysterious illness and another cast member is murdered, it looks like someone doesn't want the show to go on.<br/><br/><b>AWARDS:</b><br/>Romantic Times Top Pick<br/>Reviewer's Choice Awards, finalist<br/><br/><b>THE DAISY GUMM MAJESTY MYSTERIES,</b> in series order<br/><i>Strong Spirits<br/>Fine Spirits<br/>High Spirits<br/>Hungry Spirits<br/>Genteel Spirits<br/>Ancient Spirits<br/>Spirits Revived<br/>Dark Spirits<br/>Spirits Onstage<br/>Unsettled Spirits<br/>Bruised Spirits<br/>Spirits United<br/>Spirits Unearthed<br/>Shaken Spirits<br/>Scarlet Spirits</i><br/><br/>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Alice Duncan
      </h2>
      
      <p class="authorDescription body article">In an effort to avoid what she knew she should be doing, Alice folk-danced professionally until her writing muse finally had its way. Now a resident of Roswell, New Mexico, Alice enjoys saying &quot;no&quot; to smog, &quot;no&quot; to crowds, and &quot;yes&quot; to loving her herd of wild dachshunds. Visit Alice at www.aliceduncan.net.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      ePublishing Works
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1c8f3fd6